'use client';

import type { PropsWithChildren } from 'react';
import { useParams } from 'next/navigation';
import { ensureString } from '@frameio/utils/formatters';
import { IsolatedActiveProjectIdContextProvider } from '../ActiveProjectIdContext';

/**
 * Helper context to derive the active project id
 *
 * This context guarantees that the active project ID is related to the IDs
 * in the route.
 *
 * Note: because this fetch must be initiated from the client, it's not
 * available until very late in the page load process.
 */
export const ActiveProjectIdFromParams = (props: PropsWithChildren) => {
  const params = useParams();
  const projectId = ensureString(params.projectId);

  return (
    <IsolatedActiveProjectIdContextProvider projectId={projectId}>
      {props.children}
    </IsolatedActiveProjectIdContextProvider>
  );
};
